import { AuthShopOpenMode } from 'services/api/flagr';
import chatttSDK from 'services/chattt';
import { openExternalURL } from 'utils/openExternalURL';
import { useBrowserSettings } from 'hooks/business/system/useBrowserSettings';

const useOpenURL = () => {
  const browserSettings = useBrowserSettings();

  const openURL = (url: string, openMode?: AuthShopOpenMode) => {
    if (openMode === 'external' || browserSettings === 'system' || !chatttSDK) {
      openExternalURL(url);
    } else if (chatttSDK?.app?.openInnerBrowser) {
      chatttSDK.app.openInnerBrowser(url, {
        // 临时 session
        partition: Date.now().toString(),
      });
    } else {
      chatttSDK?.app?.createWindow(url, {
        width: 1000,
        height: 800,
        webPreferences: {
          // 临时 session
          partition: Date.now().toString(),
        },
      });
    }
  };

  return openURL;
};

export default useOpenURL;
